(function(){
  // 0) ricava il section.id dal <template>
  var tpl = document.querySelector('[id^="variant-liters-map-"]');
  if(!tpl) return;
  var secId = tpl.id.replace('variant-liters-map-','');

  // 1) leggi mappa variantId -> stringa "0,75 L"
  var json = tpl.innerHTML || tpl.textContent || '{}';
  var litersMap = {};
  try { litersMap = JSON.parse(json) || {}; } catch(e) {}

  // 2) prendi i nodi target
  var rowEl   = document.getElementById('liters-row-' + secId);
  var valueEl = document.getElementById('liters-value-' + secId);
  if(!rowEl || !valueEl) return;

  // 3) renderer
  function setLiters(variantId){
    var val = litersMap[String(variantId)] || '';
    if(!val || String(val).trim() === ''){
      rowEl.style.display = 'none';
      valueEl.textContent = '';
    } else {
      rowEl.style.display = '';
      valueEl.textContent = val; // già formattato in Liquid (es. "0,75 L")
    }
  }

  // 4) evento nativo dei temi moderni (Split/Dawn)
  document.addEventListener('variant:change', function(e){
    var v = e.detail && e.detail.variant;
    if(v && v.id) setLiters(v.id);
  });

  // 5) fallback: ascolta cambi nel form varianti
  var form = document.querySelector('form[action*="/cart/add"]');
  if(form){
    form.addEventListener('change', function(){
      var idInput = form.querySelector('input[name="id"]');
      var select  = form.querySelector('select[name="id"]');
      var variantId = (idInput && idInput.value) || (select && select.value);
      if(variantId) setLiters(variantId);
    });

    // alcuni temi sostituiscono l’input id dinamicamente
    new MutationObserver(function(){
      var idInput = form.querySelector('input[name="id"]');
      if(idInput && idInput.value) setLiters(idInput.value);
    }).observe(form, {subtree:true, childList:true});
  }

  // 6) init con la variante corrente
  (function(){
    var initialId = null;
    if(form){
      var idInput = form.querySelector('input[name="id"]');
      var select  = form.querySelector('select[name="id"]');
      initialId = (idInput && idInput.value) || (select && select.value);
    }
    if(!initialId){
      var keys = Object.keys(litersMap);
      if(keys.length) initialId = keys[0];
    }
    if(initialId) setLiters(initialId);
  })();
})();